module.exports = __webpack_public_path__ + "static/media/om_sjukmat2.7dc98396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/om_sjukmat2.png
// module id = 119
// module chunks = 0